import { FormHandles, SubmitHandler } from "@unform/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from '@unform/web'
import * as Yup from 'yup'
import { useHistory } from "react-router-dom";
import { BsCheckLg, BsKey, BsXLg  } from 'react-icons/bs';

import { ToastContext } from "../../contexts/toast/toastContext";
import Logo from "../../assets/imgs/logo-eg.svg";
import { Input } from "../../components/Form";
import { getSingleErrorMessage } from "../../helpers/getSingleErrorMessage";
import getValidationErrors from "../../helpers/getValidateErrors";
import api from "../../services/api";
import { useLocation } from "react-router-dom";

interface ICadastrarSenha{
    senha:string,
    confirmacaoSenha:string,
    codigoAcesso:string,
    token: string
}

const CadastrarSenha: React.FC = () => {

    const formRef = useRef<FormHandles>(null);
    const [loading, setLoading] = useState(false);
    const [upperCase, setUpperCase] = useState(false);
    const [hasNumber, setHasNumber] = useState(false);
    const [hasMin, setHasMin] = useState(false);
    const [hasMax, setHasMax] = useState(false);
    const [samePassword, setSamePassword] = useState(false);
    const toastContext = useContext(ToastContext);
    let { search } = useLocation();
    const history = useHistory();
    
    const schema = Yup.object().shape({
        senha: Yup.string()
                .matches(/^(?=.*?[a-z])/,"A senha precisa ter pelo menos uma letra.")
                .matches(/^(?=.*?[0-9])/, "A senha precisa ter pelo menos um número.")
                .matches(/^(?=.*?[0-9])/, "A senha precisa ter no mínimo 6 caracteres.")
                .matches(/^(?=.*?[0-9])/, "A senha não pode ter mais do que 14 caracteres.")
                .min(6, 'A senha precisa ter no mínimo 6 caracteres.')
                .max(14, 'A senha precisa ter no máximo 14 caracteres.')
                .required('A senha é obrigatória.'),

        confirmacaoSenha: Yup.string()
            .oneOf([Yup.ref("senha"), null], "Senha não confere. Digite a mesma senha nos dois campos."),
        
        codigoAcesso: Yup
                .string()
                .required("Código de acesso é obrigatório.")
      });

    useEffect(() =>{
        formRef.current?.setErrors({});
    });

    const ValidateField = (password: string) => {
        setUpperCase(new RegExp(/^(?=.*?[a-z,A-Z])/).test(password));
        setHasNumber(new RegExp(/^(?=.*?[0-9])/).test(password));
        setHasMin(new RegExp(/^[^\s]{6,}$/).test(password));
        setHasMax(new RegExp(/^[^\s]{0,14}$/).test(password));

    }

    const ValidateSamePassword = (password: string) => {
        if(formRef?.current?.getFieldValue("confirmaSenha") != '')
            setSamePassword(formRef?.current?.getFieldValue("confirmaSenha") === formRef?.current?.getFieldValue("senha"));
    }

    const handleSubmit: SubmitHandler<ICadastrarSenha> = async (form) => {
        try{
            setLoading(true);
            const query = new URLSearchParams(search);
            form.token = query.get("t") || '';
            
            await schema.validate(form, { abortEarly: false })
            
           var response = await api.post("acesso/cadastrar-senha", form);

           if(response.data)
           {
                toastContext.notification("Senha cadastrada com sucesso.", "success");
                setTimeout(() => history.push("/"), 4000);
           }
           else 
           {
                toastContext.notification("Código de Acesso inválido.", "success");
           }
            
        }catch(error: any){
            if (error instanceof Yup.ValidationError)
            {
                formRef.current?.setErrors(getValidationErrors(error));
            }
            else
            {
                toastContext.notification(getSingleErrorMessage(error), "error");
            }  
        }finally{
            setLoading(false);
        }
    }

    return (
        <div>
            <div className="page-main">
                <header className="navbar navbar-eg navbar-expand-md pb-2">
                    <div className="container-xl px-3">
                        <a className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pr-0 pr-md-4">
                            <img
                                src={Logo}
                                height="32"
                                className="navbar-brand-image"
                            /> 
                        </a>
                    </div>
                </header>
                <div id="container" className="container mt-3 d-flex justify-content-center">
                    <Form className="card" style={{ width: "60%", padding: "20px" }} ref={formRef} onSubmit={handleSubmit}>
                    <div className="text-center">
                        <h2>Valide sua conta para ter acesso ao Portal do cliente</h2>
                        <h4>Cadastre uma senha e informe o código recebido por e-mail</h4>
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Senha</label>
                            <Input type="password" name="senha" className="form-control" placeholder="Digite sua senha..."
                                onChange={(e:any) => ValidateField(e.target.value)} />
                            <div className="my-3">
                                <ul>
                                    <li style={{color: upperCase ? "green" : "red"}}>
                                        A senha precisa ter pelo menos uma letra. {upperCase ? <BsCheckLg/> : <BsXLg/>}
                                    </li>
                                    <li style={{color: hasNumber ? "green" : "red"}}>
                                        A senha precisa ter pelo menos um número. {hasNumber ? <BsCheckLg/> : <BsXLg/>}
                                    </li>
                                    <li style={{color: hasMin ? "green" : "red"}}>
                                    A senha precisa ter no mínimo 6 caracteres. {hasMin ? <BsCheckLg/> : <BsXLg/>}
                                    </li>
                                    <li style={{color: hasMax ? "green" : "red"}}>
                                    A senha não pode ter mais do que 14 caracteres. {hasMax ? <BsCheckLg/> : <BsXLg/>}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div>
                            <label className="form-label">Confirmação da Senha</label>
                            <Input type="password" name="confirmaSenha" className="form-control" placeholder="Digite sua senha novamente..."
                                onChange={(e:any) => ValidateSamePassword(e.target.value)} />
                            <div className="mt-3">
                                <ul>
                                    <li style={{color: samePassword ? "green" : "red"}}>
                                        As senhas precisam ser iguais {samePassword ? <BsCheckLg/> : <BsXLg/>}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="mt-3">
                            <label className="form-label">Código de Acesso</label>
                            <Input type="text" name="codigoAcesso" className="form-control" placeholder="Digite o código de acesso..." />
                        </div>

                        <div className="mt-3">
                            <button type="submit" disabled={!(upperCase && hasNumber && samePassword)} className={"btn btn-primary btn-block" + (loading ? " disabled" : "")}>
                                {loading ? "Gravando..." : "Gravar Senha"}
                                <BsKey className="ml-2"/>
                            </button>
                        </div>
                    </Form>
                </div>
            </div>

        </div>
    )
}

export default CadastrarSenha;
